import dayjs from 'dayjs';

import {
  GrassCalendarContainer,
  DEFAULT_GRASS_COUNT,
} from './GrassCalendar.parts';

import { GrassTile } from '@/features/Landing';
import { EmptyGrassTile } from '@/features/Landing/Grass/GrassBody.parts';

const GrassCalendarSkeleton = () => {
  const startDate = dayjs().startOf('year');
  const endDate = dayjs().endOf('year');
  const daysDiff = endDate.diff(startDate, 'day') + 1;
  const startDay = startDate.day();
  const leftDay = DEFAULT_GRASS_COUNT - startDay - daysDiff;

  return (
    <GrassCalendarContainer>
      {Array.from({ length: startDay }).map((_, index) => (
        <EmptyGrassTile key={`before-${index}`} id={`before-${index}`} />
      ))}
      {Array.from({ length: daysDiff }).map((_, index) => (
        <GrassTile
          key={index}
          date={dayjs().subtract(index, 'day').format('YYYY-MM-DD')}
          score={0}
          colorLevel={0}
        />
      ))}
      {Array.from({ length: leftDay }).map((_, index) => (
        <EmptyGrassTile key={`after-${index}`} id={`after-${index}`} />
      ))}
    </GrassCalendarContainer>
  );
};

export default GrassCalendarSkeleton;
